import { useTranslation } from 'react-i18next'

import { Skeleton } from 'src/components/atoms'

const PLACEHOLDER_COUNT = 10

export const CompanyGridSkeleton = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      aria-label={t('whyWeInvest.loadingAriaLabel')}
      aria-busy="true"
      className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5"
    >
      {Array.from({ length: PLACEHOLDER_COUNT }).map((_, index) => (
        <div key={index} className="flex justify-center">
          <Skeleton.Base className="aspect-square w-full max-w-[228px] rounded-[12px]" />
        </div>
      ))}
    </div>
  )
}
